import {FormSectionHeading} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {useAiFillFlash, useFieldAiProps} from '@/features/ai-extraction';

import {PurchasePriceField} from './PurchasePriceField';

import type {AiSuggestion} from '@/features/ai-extraction';
import type {CreateBuyerFormValues} from '@/features/buyers/validation';
import type {FC} from 'react';
import type {UseFormReturn} from 'react-hook-form';

export interface PurchasePriceSectionProps {
  form: UseFormReturn<CreateBuyerFormValues>;
  aiFields: Map<string, AiSuggestion>;
  isProcessing: boolean;
  markFieldModified: (field: string) => void;
}

/** The price on its own, for deal types that generate the asset instead of asking for one. */
export const PurchasePriceSection: FC<PurchasePriceSectionProps> = ({
  form,
  aiFields,
  isProcessing,
  markFieldModified
}) => {
  const {t} = useTranslation('trustAccounts');
  const fieldAi = useFieldAiProps({
    aiFields,
    isProcessing,
    markFieldModified,
    getValue: form.getValues
  });
  const isFlashing = useAiFillFlash(aiFields);

  return (
    <div className="flex flex-col gap-4">
      <FormSectionHeading title={t('view.buyers.addBuyerModal.purchaseDetails.title')} />

      <PurchasePriceField form={form} fieldAi={fieldAi} isFlashing={isFlashing} />
    </div>
  );
};
